import { Component, Input, OnInit } from '@angular/core';
import { AuthStoreService, ContentStoreService } from '@motivforce/mx-library-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, map } from 'rxjs';
import { PromotionBigBangSideBarData } from 'src/app/core/model/promotion/promotion-big-bang-sidebar-data';
import { SiteSettings } from 'src/app/core/model/site-settings';

@UntilDestroy()
@Component({
  selector: 'app-big-bang-summary-ticket-widget',
  templateUrl: './big-bang-summary-ticket-widget.component.html',
  styleUrls: ['./big-bang-summary-ticket-widget.component.scss'],
})
export class BigBangSummaryTicketWidgetComponent implements OnInit {
  @Input() bigBangSideBarData: PromotionBigBangSideBarData;

  endDate: Date;
  user$ = this.authStore.userSettings$.pipe(map((settings) => (settings ? settings.user : null)));
  showTimer = false;
  firstTicketCompletedPercentage = 0;
  secondTicketCompletedPercentage = 0;
  thirdTicketCompletedPercentage = 0;
  numberOfCompletedTickets = 0;
  pointsTillNextTicket = 0;
  prizeDrawQuarter: string;

  constructor(private authStore: AuthStoreService, private contentStore: ContentStoreService) {}

  ngOnInit(): void {
    if (this.bigBangSideBarData) {
      this.prizeDrawQuarter = this.bigBangSideBarData.quarter;
    }

    this.contentStore.siteSettings$.pipe(filter(Boolean), untilDestroyed(this)).subscribe((settings) => {
      const { siteSettings } = settings as SiteSettings;
      if (siteSettings.bigBangQuarterDrawEndDate) {
        this.endDate = new Date(siteSettings.bigBangQuarterDrawEndDate);
        this.setPrizeDrawQuarter(this.endDate);
      }
    });

    this.calucateCompletedTicketsPercentage();
  }

  private calucateCompletedTicketsPercentage(): void {
    if (this.bigBangSideBarData) {
      const tiers = this.bigBangSideBarData.tier;
      const currentPoints = this.bigBangSideBarData.quarterPoints;

      if (currentPoints >= tiers.oneTicketPoints) {
        this.firstTicketCompletedPercentage = 100;
        this.numberOfCompletedTickets = 1;
      } else {
        this.firstTicketCompletedPercentage = (currentPoints / tiers.oneTicketPoints) * 100;
        this.pointsTillNextTicket = tiers.oneTicketPoints - currentPoints;
        return;
      }

      if (currentPoints >= tiers.twoTicketsPoints) {
        this.secondTicketCompletedPercentage = 100;
        this.numberOfCompletedTickets = 2;
      } else {
        this.secondTicketCompletedPercentage =
          ((currentPoints - tiers.oneTicketPoints) / (tiers.twoTicketsPoints - tiers.oneTicketPoints)) * 100;
        this.pointsTillNextTicket = tiers.twoTicketsPoints - currentPoints;
        return;
      }

      if (currentPoints >= tiers.threeTicketsPoints) {
        this.thirdTicketCompletedPercentage = 100;
        this.numberOfCompletedTickets = 3;
      } else {
        this.thirdTicketCompletedPercentage =
          ((currentPoints - tiers.twoTicketsPoints) / (tiers.threeTicketsPoints - tiers.twoTicketsPoints)) * 100;
        this.pointsTillNextTicket = tiers.threeTicketsPoints - currentPoints;
      }
    }
  }

  private setPrizeDrawQuarter(endDrawDate: Date) {
    const today = new Date();
    if (endDrawDate && today.getMonth() === endDrawDate.getMonth() && today.getTime() < endDrawDate.getTime()) {
      this.prizeDrawQuarter = `Q${this.getPreviousQuarter()}`;
    } else this.prizeDrawQuarter = this.bigBangSideBarData.quarter;
  }

  private getPreviousQuarter(): number {
    const month = new Date().getMonth();
    let currentQuarter: number;

    if (month >= 3 && month <= 5) currentQuarter = 1;
    else if (month >= 6 && month <= 8) currentQuarter = 2;
    else if (month >= 9 && month <= 11) currentQuarter = 3;
    else currentQuarter = 4;

    return currentQuarter === 1 ? 4 : currentQuarter - 1;
  }
}
